module.exports = __webpack_public_path__ + "static/media/iconCards.22af4b4a.svg";